<template>
  <div>
    <div class="key-visual">
      <div class="mask">
        <div class="contents">
          <div class="txt">
            <span>e·motion global</span>은<br />
            <span>e·very brand</span>가 원하는<br />
            <span>e·xclusive solution</span>을<br />제공합니다
          </div>
        </div>
        <div class="bg"></div>
      </div>
    </div>
    <div class="tab-contents tab-scroll">
      <tab-item v-if="!selectShow" :list="tab.list" :name="tab.name" v-model="tab.active" />
      <form-select
        v-else
        type="tab"
        v-model="tab.active"
        :options="
          tab.list.map(el => {
            return {
              value: String(el.id),
              label: el.title
            };
          })
        "
      />
      <div class="marketing-wrap">
        <div class="contents">
          <!-- Brand Marketing [S] -->
          <div v-show="tab.active === '0'" class="brand-marketing">
            <section class="section section-1">
              <h3 class="section-title">
                정교한 분석과 혁신적 솔루션으로<br/>
                브랜드의 잠재력을 극대화하는<br/>
                차별화된 경험을 창조해냅니다.
              </h3>
              <!-- 로띠 -->
              <div class="lottie-cont lottie-01">
                <lottie-marketing01 />
              </div>
            </section>
            <!--<div class="bg-img"><img src="@/assets/images/marketing/lottie.png" alt="로띠"></div>-->
            <section class="section section-2">
              <h3 class="section-title">Brand Marketing</h3>
              <p class="section-txt">
                퍼포먼스 마케팅 저성장 시대에 무엇보다 고객이 공감하고 몰입이 가능한 경험을 제공할 수 있는 브랜드 마케팅을 위한 research · planning · bx design · guidance · action 프로세스로 제시합니다.
              </p>
              <p class="section-subTit">Marketing Process</p>
              <ul class="process-list">
                <li>
                  <h4 class="tit">
                    <span class="num">01</span> Research
                  </h4>
                  <div class="img">
                    <img src="@/assets/images/marketing/brand01.png" alt="Research" />
                  </div>
                  <div class="desc">
                    <p class="txt">브랜드와 시장, 경쟁사에 대한 기초 조사를 통해 핵심 인사이트와 전략 수립의 기반을 마련합니다. 브랜드의 본질을 파악하고 방향성을 설정하는 출발점입니다.</p>
                  </div>
                </li>
                <li>
                  <h4 class="tit">
                    <span class="num">02</span> Planning
                  </h4>
                  <div class="img">
                    <img src="@/assets/images/marketing/brand02.png" alt="Planning" />
                  </div>
                  <div class="desc">
                    <p class="txt">
                      브랜드의 방향성과 구조를 정리하고 디자인 원칙과 체계를 명확히 설정하고, 체계적인 전략 수립으로 일관된 실행을 위한 기틀을 만듭니다.
                    </p>
                  </div>
                </li>
                <li>
                  <h4 class="tit">
                    <span class="num">03</span> BX design
                  </h4>
                  <div class="img">
                    <img src="@/assets/images/marketing/brand03.png" alt="BX design" />
                  </div>
                  <div class="desc">
                    <p class="txt">
                      언어적‧시각적 자산을 개발해 브랜드의 표현력을 강화하고 디자인 시스템을 통해 일관된 사용자 경험을 설계합니다. 브랜드의 개성을 구체화하고 시각적으로 전달하는 핵심 단계입니다.
                    </p>
                  </div>
                </li>
                <li>
                  <h4 class="tit">
                    <span class="num">04</span> Guidance
                  </h4>
                  <div class="img">
                    <img src="@/assets/images/marketing/brand04.png" alt="Guidance" />
                  </div>
                  <div class="desc">
                    <p class="txt">
                      브랜드 활용 기준을 정리한 가이드라인을 제작하여 내부 운영과 외부 커뮤니케이션의 일관성을 확보합니다. 이를 통해 이해관계자들이 브랜드를 이해하고 활용할 수 있도록 돕습니다.
                    </p>
                  </div>
                </li>
                <li>
                  <h4 class="tit">
                    <span class="num">05</span> Action
                  </h4>
                  <div class="img">
                    <img src="@/assets/images/marketing/brand05.png" alt="Action" />
                  </div>
                  <div class="desc">
                    <p class="txt">정립된 브랜드 자산을 다양한 접점에 적용하여 실질적인 브랜드 경험을 구현합니다. 현장 중심의 실행으로 브랜드의 가치를 현실화합니다.</p>
                  </div>
                </li>
              </ul>
            </section>
          </div>
          <!-- Brand Marketing [E] -->

          <!-- Creative Campaign [S] -->
          <div v-show="tab.active === '1'" class="creative-campaign">
            <section class="section section-1">
              <h3 class="section-title">Creative Campaign</h3>
              <p class="section-txt">
                브랜드의 pain point를 캐치하고 기존 데이터에 기반한 인사이트를 도출하여 고객 집착적인 컨셉 및 메시지, 캠페인 전략을 산출하고, 디지털부터 OOH까지 고객이 자발적 바이럴을 끌어낼 수 있는 캠페인을 전개합니다.
              </p>
            </section>
            <div class="bg-img"><img src="@/assets/images/marketing/create01.png" alt="Creative Campaign 프로세스"></div>
            <section class="section swiper">
              <div class="swiper-section" ref="swiperSection">
                <swiper class="swiper-container" :options="swiperOptions">
                  <swiper-slide
                    v-for="(item, index) in swiperData"
                    :key="index"
                    :style="`background: url(${item.bgImg}) center / cover no-repeat`"
                  >
                    <div class="inner">
                      <div
                        class="logo swiper-text"
                        :style="`background: url(${item.logoImg}) 0 0 / cover no-repeat`"
                      >
                        {{ item.title }}
                      </div>
                      <h3 class="title swiper-text">
                        <strong v-html="item.title_1"></strong>
                        {{ item.title_2 }}
                      </h3>
                      <p class="sm-tit swiper-text">
                        {{ item.sm_tit }}
                      </p>
                      <p class="sm-txt swiper-text">
                        {{ item.sm_txt }}
                      </p>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-button-next">
                  <img src="@/assets/icons/ic_nav.svg" alt="swiper_arrow" />
                </div>
                <div class="swiper-button-prev">
                  <img src="@/assets/icons/ic_nav.svg" alt="swiper_arrow" />
                </div>
              </div>
            </section>
          </div>
          <!-- Creative Campaign [E] -->

          <!-- AD Marketing [S] -->
          <div v-show="tab.active === '2'" class="ad-marketing">
            <section class="section section-1">
              <h3 class="section-title">
                AD Marketing
              </h3>
              <p class="section-txt">고객 데이터와 최신 트렌드를 기반으로 맞춤 전략을 실행하여, 광고 성과를 극대화하고 꾸준한 잠재 고객 유입과 구매 전환으로 비즈니스 효율을 향상시킵니다.</p>
            </section>
            <div class="bg-img"><img src="@/assets/images/marketing/ad01.png" alt="AD Marketing 비지니스 효율"></div>
          </div>
          <!-- AD Marketing [E] -->

          <!-- AI Studio [S] -->
          <div v-show="tab.active === '3'" class="ai-studio">
            <section class="section section-1">
              <h3 class="section-title">
                AI Studio
              </h3>
              <p class="section-txt">브랜드에 내재된 고유한 비주얼 자산을 분석한 데이터를 기반으로 영상, 이미지, 모델 등 AI 제너레이팅 툴을 통해 기존 광고, 숏폼 콘텐츠를 카테고리별 프롬프트 스토리텔링과 결합하여 새로운 유형의 콘텐츠로 구현합니다. </p>
            </section>
            <div class="bg-img"><img src="@/assets/images/marketing/ai01.png" alt="AI Studio 프로세스"></div>
          </div>
          <!-- AI Studio [E] -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Swiper, SwiperSlide} from "vue-awesome-swiper";
  import modalComponent from "@/components/global/modal-component.vue";
  import "swiper/css/swiper.css";
  import {TweenMax, Power0} from "gsap/all";
  import {Power2} from "gsap";
  import {commonMethods} from "@/utils/common-methods";
  import LottieMarketing01 from "@/components/lottie/marketing01.vue";

  export default {
    name: "Marketing",
    metaInfo() {
      return {
        title: "Marketing",
        titleTemplate: "%s | e · motion"
      };
    },
    components: {LottieMarketing01, Swiper, SwiperSlide, modalComponent},
    mixins: [commonMethods],
    data() {
      return {
        selectShow: false,
        tab: {
          name: "marketing-tab",
          list: [
            {
              id: "0",
              title: "Brand Marketing"
            },
            {
              id: "1",
              title: "Creative Campaign"
            },
            {
              id: "2",
              title: "AD Marketing"
            },
            {
              id: "3",
              title: "AI Studio"
            }
          ],
          active: "0"
        },
        isOpen: false,
        scrollPosition: 0,
        isOpen2: false,
        scrollPosition2: 0,
        isModalOpen: false,
        swiperData: [
          {
            title: "DORCO",
            bgImg: require("@/assets/images/marketing/swiper_bg01.png"),
            logoImg: require("@/assets/images/marketing/swiper_logo_dorco.png"),
            title_1: "도루코 바버샵",
            title_2: "버스 캠페인",
            sm_tit: "Marketing",
            sm_txt:
              "남자들을 위한 특별한 서비스를 경험할 수 있는 프로젝트로서 도루코 바버샵 브랜드 사이트에서 진행된 이벤트를 통해 ‘특별한 날’이 필요한 사연을 받아 신청자들 중 매주 1명씩 선발하여 전문 바버의 쉐이빙 서비스를 직접 경험하게 하고, 그들만의 특별한 날을 선물하는 프로모션을 진행했습니다."
          },
          {
            title: "SK telecom",
            bgImg: require("@/assets/images/marketing/swiper_bg02.png"),
            logoImg: require("@/assets/images/marketing/swiper_logo_lgU.png"),
            title_1: "LG U+ tv G 우퍼",
            title_2: "바이럴 영상 캠페인",
            sm_tit: "Marketing",
            sm_txt:
              "황치열, 홍대 기타 여신 리싸와 함께 90년대 메가 히트곡인 솔리드의 ‘이 밤의 끝을 잡고’를 모던 록으로 리메이크한 뮤직비디오를 제작, 뮤직비디오 속 두 명의 모델과 함께 LG U+ tv G 우퍼를 지속적으로 노출하고, 콘서트의 감동을 집안에서도 누릴 수 있다는 키 메시지를 전달하였습니다."
          },
          {
            title: "POPEYES",
            bgImg: require("@/assets/images/marketing/swiper_bg03.png"),
            logoImg: require("@/assets/images/marketing/swiper_logo_popeyes.png"),
            title_1: "파파이스",
            title_2: "디지털 캠페인",
            sm_tit: "Marketing",
            sm_txt:
              "파파이스는 브랜드 정체성 강화와 고객 접점 확대를 위해 전국 매장에서 '스파이시 걸' 선발 프로모션을 디지털 플랫폼과 연계하여 대규모로 진행하였습니다. 이 캠페인은 오프라인 이벤트와 온라인 참여를 결합하여 소비자들의 자발적 참여와 함께 파파이스 브랜드 경험 전달을 극대화하였습니다."
          }
        ],
        swiperOptions: {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        }
      };
    },
    computed: {},
    watch: {
      "tab.active"() {
        this.init();
      },
      isValid() {
        if (this.isValid) {
          this.isError = false;
        }
      },
      GE_CONT_HEIGHT() {
        if (this.$el.offsetParent) {
          this.init();
        }
      }
    },
    activated() {
      this.init();
    },
    mounted() {
      this.init();
      this.initSwiperPosition();
      window.addEventListener("scroll", this.handleScroll);
      document.addEventListener("scroll", this.windowScrollEvt);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
      document.removeEventListener("scroll", this.windowScrollEvt);
    },
    methods: {
      windowScrollEvt() {
        const tabContents = document.querySelector(".tab-contents");
        if (tabContents) {
          if (tabContents.offsetTop <= window.scrollY + 1) {
            this.selectShow = true;
          } else {
            this.selectShow = false;
          }
        }
      },
      init() {
        this.scene?.destroy(true);
        const keyVisual = document.querySelector(".key-visual");
        const tween = TweenMax.to(keyVisual.querySelector(".bg"), 1, {
          y: keyVisual.clientHeight,
          ease: Power0.easeInOut
        });
        const tween2 = TweenMax.to(keyVisual.querySelector(".txt"), 1, {
          y: keyVisual.clientHeight + keyVisual.querySelector(".txt").clientHeight,
          ease: Power0.easeInOut
        });
        this.scene = this.$scrollmagic
          .scene({
            triggerElement: keyVisual,
            triggerHook: 0,
            duration: keyVisual.clientHeight * 2
          })
          .setTween([tween, tween2]);
        this.$scrollmagic.addScene(this.scene);
      },
      initSwiperPosition() {
        const swiperSection = this.$refs.swiperSection;
        if (swiperSection) {
          TweenMax.set(swiperSection, {
            width: "100%",
            height: "100vh",
            position: "relative",
            margin: "10px auto 0",
            clipPath: "inset(0% 5% 85%)" // 상단 중간 부분만 보이도록 설정
          });
        }
      },
      handleScroll() {
        const scrollY = window.scrollY || window.pageYOffset;
        const swiperSection = this.$refs.swiperSection;
        // console.log("swiperSection", swiperSection);
        // console.log("scrollY", scrollY);
        if (swiperSection) {
          const sectionTop = swiperSection.offsetTop;
          const swiperHeight = window.innerHeight;
          const startScroll = sectionTop - swiperHeight * 0.7; // 스크롤 높이 30%에서 확장 시작
          const progress = Math.min(1, Math.max(0, (scrollY - startScroll) / (swiperHeight * 0.3))); // 30% 스크롤 내에서 확장 완료
          const insetBottom = 85 - 85 * progress; // 아래쪽 영역이 점점 확장되도록 변경
          const insetX = 5 - 5 * progress;
          TweenMax.to(swiperSection, 1, {
            clipPath: `inset(0% ${insetX}% ${insetBottom}% ${insetX}%)`,
            ease: Power2.easeOut,
            onUpdate: () => {
              // console.log("progress", progress);
              if (progress >= 0.25) {
                this.isExpanded = true;
                document.querySelectorAll(".swiper-text").forEach((text, index) => {
                  TweenMax.to(text, 1, {
                    opacity: 1,
                    y: 0,
                    delay: index * 0.1,
                    ease: Power2.easeOut
                  });
                });
              } else {
                this.isExpanded = false;
                document.querySelectorAll(".swiper-text").forEach(text => {
                  TweenMax.to(text, 0.5, {
                    opacity: 0,
                    y: 20,
                    ease: Power2.easeOut
                  });
                });
              }
            }
          });
        }
      }
    },
    destroyed() {}
  };
</script>
<style lang="scss" scoped>
  .key-visual {
    position: relative;
    min-height: 779px;
    height: 100vh;
    min-width: $globalWidth;
    .mask {
      height: 100%;
      position: relative;
      overflow: hidden;
    }
    .contents {
      z-index: 2;
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      .txt {
        margin-top: -30px;
        height: 369px;
        color: #fff;
        font-weight: 700;
        font-size: 30px;
        line-height: 43px;
        letter-spacing: -0.03em;
        span {
          @include montserrat;
        }
      }
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      min-width: $globalWidth;
      height: 100%;
      width: 100%;
      background: url(../../assets/images/marketing/img_marketing_main.png) center center / cover
        no-repeat;
    }
  }
  .swiper-section {
    width: 100vw;
    height: 100vh;
    position: relative;
    margin: 10px auto 0;
    overflow: hidden;
    .swiper-button-next,
    .swiper-button-prev {
      position: absolute;
      top: 520px;
      z-index: 10;
      width: 36px;
      height: 36px;
      backdrop-filter: blur(200px);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      img {
        width: 18px;
        height: 18px;
      }
      &:after {
        display: none !important;
      }
    }
    .swiper-button-prev {
      left: 20px;
    }
    .swiper-button-next {
      left: 66px;
      transform: rotate(180deg);
    }
    .swiper-container {
      width: 100%;
      height: 100%;

      .swiper-slide {
        padding: 20.625vh 20px 0 20px;
        box-sizing: border-box;
        .inner {
          .logo {
            font-size: 0;
            text-indent: -9999px;
            width: 160px;
            height: 44px;
          }
          .title {
            margin-top: 46px;
            color: #fff;
            font-size: 18px;
            font-weight: 400;
            line-height: 28px;
            letter-spacing: -0.9px;
            strong {
              font-weight: 700;
              display: block;
            }
          }
          .sm-tit {
            margin-top: 30px;
            color: #fff;
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: -0.7px;
            font-family: Montserrat, "Noto Sans KR", sans-serif;
          }
          .sm-txt {
            margin-top: 10px;
            color: #fff;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.7px;
            word-break: keep-all;
          }
        }
      }
    }
    .swiper-text {
      opacity: 0;
    }
  }
  .lottie-cont {
    min-width: 320px;
    &.lottie-01 {
      margin-top: 20px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .section {
    padding: 0 20px;
    word-break: keep-all;

    &.swiper {
      margin-top: 120px;
      padding: 0;
      .section-title {
        padding: 0 20px;
      }
    }
  }
  .section-1 {
    position: relative;
    margin-top: 70px;
  }
  .section-2 {
    margin-top: 100px;

    .puzzle-img {
      width: 55.56px;
      height: 20px;
    }
  }

  .section-title {
    color: #101010;
    font-family: Montserrat, "Noto Sans KR", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: -1px;
    .sub {
      display: block;
      color: #ee2c3c;
      font-family: "Noto Sans KR", sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.7px;
    }
  }
  .section-subTit {
    font-family: Montserrat, "Noto Sans KR", sans-serif;
    font-size: 16px;
    font-weight: bold;
    color: #101010;
    margin-top: 50px;
  }
  .section-txt {
    margin-top: 10px;
    color: #101010;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.8px;
  }

  .cont-inner {
    height: 374px;
    overflow: hidden;
    position: relative;
    margin-top: 20px;
    &.open {
      height: auto;
      padding-bottom: 15px;
      + .btn-open {
        &:after {
          transform: translateY(-50%) rotate(180deg);
        }
      }
      &:before {
        display: none;
      }
    }
    &:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
      background: url(../../assets/images/consulting/blur.png) center center / cover no-repeat;
    }
  }
  .process-list {
    margin-top: 27px;
    li {
      + li {
        margin-top: 54px;
      }
      .tit {
        color: #101010;
        font-family: Montserrat, "Noto Sans KR", sans-serif;
        font-size: 16px;
        line-height: 16px;
        font-weight: 700;
        .num {
          color: #ee2c3c;
          font-family: Montserrat, "Noto Sans KR", sans-serif;
          font-size: 16px;
          line-height: 16px;
        }
      }
      .img {
        margin-top: 20px;
      }
      .desc {
        margin-top: 30px;
        padding-top: 30px;
        border-top: 1px solid #ddd;
        .txt {
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: -0.5px;
          + .txt {
            margin-top: 10px;
          }
        }
      }
    }
  }
  .bg-img {
    margin: 50px 20px;
  }
  .modal-title span {
    opacity: 0.5;
    font-weight: 400;
  }

  .marketing-wrap {
    .contents {
      width: 100%;
      padding: 0;
    }

    .brand-marketing {
      .section-2 {
        margin: 100px auto 200px;
      }
    }

    .ad-marketing, .ai-studio {
      .bg-img {
        margin: 50px 20px 200px;
      }
    }
  }
</style>
